module.exports = __webpack_public_path__ + "img/5_no.607a59c7.svg";